<!-- 
    Inline
    Renders content horizontally with consistent spacing between 
    all items, spanning multiple lines if needed.

    Borrowed from Braid Design System
    https://seek-oss.github.io/braid-design-system/components/Inline

    <template>
        <div class="divide-y border-t-1>
            // each child wrapped in a box
            <div class="py-2"></div>
        </div>
    </template>
-->

<script>
import { isTagEmpty } from '@/util/render';
// import { validation } from '@/util/theme';
import './c-stack.css';

export default {
    props: {
        /**
        * Unique id for the element.
        */
        id: String,
        /**
        * Spacing between child elements.
        */
        spacing: {
            type: [String, Number],
            default: 2,
        },
        /**
        * Child element(s) render tag.
        */
        element: {
            type: String,
            default: 'div',
        },
        /**
        * Horizontal rules between elements.
        */
        dividers: {
            type: String,
            default: 'none',
            validator(value) {
                return [
                    'none',
                    'between',
                    'all'
                ].includes(value);
            }

        },
    },
    computed: {
        computedSpacing() {
            return parseInt(this.spacing);
        },
        padding() {
            if (this.dividers !== 'none') {
                switch (this.computedSpacing) {
                    case 1:
                        return 'py-1';
                    case 2:
                        return 'py-2';
                    case 3:
                        return 'py-3';
                    case 4:
                        return 'py-4';
                    case 5:
                        return 'py-5';
                    case 6:
                        return 'py-6';
                    default: 
                        return '';
                }
            }

            switch(this.computedSpacing) {
                case 1:
                    return 'pb-1';
                case 2:
                    return 'pb-2';
                case 3:
                    return 'pb-3';
                case 4:
                    return 'pb-4';
                case 5:
                    return 'pb-5';
                case 6:
                    return 'pb-6';
                default: 
                    return '';
            }
        },
        contain() {
            switch (this.dividers) {
                case 'between':
                    switch(this.computedSpacing) {
                        case 1:
                            return '-my-1';
                        case 2:
                            return '-my-2';
                        case 3:
                            return '-my-3';
                        case 4:
                            return '-my-4';
                        case 5:
                            return '-my-5';
                        case 6:
                            return '-my-6';
                        default: 
                            return '';
                    }
                case 'none':
                    switch(this.computedSpacing) {
                        case 1:
                            return '-mb-1';
                        case 2:
                            return '-mb-2';
                        case 3:
                            return '-mb-3';
                        case 4:
                            return '-mb-4';
                        case 5:
                            return '-mb-5';
                        case 6:
                            return '-mb-6';
                        default: 
                            return '';
                    }
                default: 
                    return '';
            }
        }
    },
    render(createElement) {
        return createElement(
            'div',
            {
                class: [
                    'c-stack',
                    this.dividers === 'all' ? `c-stack--divide` : '',
                    this.dividers === 'between' ? 'c-stack--divide-between' : '',
                    this.contain,
                ],
            },
            this.$slots.default ? this.$slots.default.map((vNode) => {
                if (isTagEmpty(vNode)) {
                    return;
                }

                return createElement(
                    'div',
                    {
                        class: ['c-stack_item', this.padding],
                    },
                    [vNode]
                );
            }) : []
        );
    },
};
</script>

